import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

const routeMap: Record<string, string> = {
  '/': 'Dashboard',
  '/invoices': 'Invoices',
  '/expenses': 'Expenses',
  '/accounting': 'Accounting',
  '/accounting/chart-of-accounts': 'Chart of Accounts',
  '/accounting/journal-entries': 'Journal Entries',
  '/accounting/reports': 'Reports',
  '/inventory': 'Inventory',
  '/inventory/items': 'Items',
  '/inventory/locations': 'Locations',
  '/inventory/transfers': 'Transfers',
  '/users': 'Users',
  '/settings': 'Settings',
  '/settings/security': 'Security',
  '/settings/general': 'General',
};

export default function Breadcrumbs() {
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i) => i);

  const breadcrumbItems: Array<{ title: ReactNode }> = [
    {
      title: (
        <Link to="/">
          <HomeOutlined />
        </Link>
      ),
    },
  ];

  pathSnippets.forEach((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    const breadcrumbName = routeMap[url] || pathSnippets[index];

    breadcrumbItems.push({
      title: (index === pathSnippets.length - 1 ? breadcrumbName : <Link to={url}>{breadcrumbName}</Link>) as ReactNode,
    });
  });

  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <Breadcrumb
      items={breadcrumbItems}
      style={{ margin: '16px 0' }}
    />
  );
}
